export const periodsOverlap = (startA, endA, startB, endB) => {
  if (!startA || !startB) return false;
  const sA = new Date(startA);
  const eA = endA ? new Date(endA) : null;
  const sB = new Date(startB);
  const eB = endB ? new Date(endB) : null;
  if (eA && sB > eA) return false;
  if (eB && sA > eB) return false;
  return true;
};

export const isMonthAdjacent = (iniciA, fiA, iniciB, fiB) => {
  if (!iniciA || !iniciB) return false;
  const dA = new Date(iniciA);
  const dB = new Date(iniciB);
  const nouInici = dA >= dB ? iniciA : iniciB;
  const anteriorFi = dA >= dB ? fiB : fiA;
  if (!anteriorFi) return false;
  const dNou = new Date(nouInici);
  const dAnt = new Date(anteriorFi);
  return (
    dNou.getFullYear() === dAnt.getFullYear() &&
    dNou.getMonth() === dAnt.getMonth()
  );
};

// Comprueba si el nuevo alumno entra en conflicto con alguno existente
// existingStudents: array con { CODI_BECARI, NOM, DNI/DNI_NIE_PASSAPORT, DATA_INICI, DATA_FINALITZACIO }
// dniField: 'DNI' o 'DNI_NIE_PASSAPORT' según el rol
export const checkStudentConflict = ({
  dni,
  iniciPractiques,
  fiPractiques,
  existingStudents,
  dniField = 'DNI',
  excludeId = null, // Para edición: ID del alumno actual, para excluirse
}) => {
  const sameDni = existingStudents.filter(
    (s) => s[dniField] === dni && s.ID_ALUMNES !== excludeId
  );

  if (sameDni.length === 0) return null;

  const conflicts = [];
  let conflictType = null;

  for (const s of sameDni) {
    if (periodsOverlap(iniciPractiques, fiPractiques, s.DATA_INICI, s.DATA_FINALITZACIO)) {
      conflictType = 'overlap';
      conflicts.push({
        codiBecari: s.CODI_BECARI,
        nom: s.NOM || s.COGNOMS_NOM,
        inici: s.DATA_INICI,
        fi: s.DATA_FINALITZACIO,
      });
    } else if (isMonthAdjacent(iniciPractiques, fiPractiques, s.DATA_INICI, s.DATA_FINALITZACIO)) {
      if (conflictType !== 'overlap') conflictType = 'monthAdjacent';
      conflicts.push({
        codiBecari: s.CODI_BECARI,
        nom: s.NOM || s.COGNOMS_NOM,
        inici: s.DATA_INICI,
        fi: s.DATA_FINALITZACIO,
      });
    }
  }

  return conflicts.length > 0 ? { conflictType, conflicts } : null;
};